import { render, staticRenderFns } from "./ShopsModule.vue?vue&type=template&id=0104afb1"
import script from "./ShopsModule.vue?vue&type=script&lang=js"
export * from "./ShopsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports